import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

import React from 'react';
import styled, { useTheme, th, up, css } from '@xstyled/styled-components';
import Highlight, { defaultProps } from 'prism-react-renderer';
import { LiveProvider, LiveEditor, LiveError, LivePreview as BaseLivePreview } from 'react-live';
import { mdx } from '@mdx-js/react';
var Pre = styled.pre(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  font-size: 15;\n  line-height: 1.45;\n  word-break: normal;\n  overflow: auto;\n  direction: ltr;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  margin: 3 -3;\n  background-color: editor-background;\n  color: editor-on;\n  direction: ltr;\n  text-align: left;\n  white-space: pre;\n  word-spacing: normal;\n  word-break: normal;\n  hyphens: none;\n  padding: 4 0;\n  border-left: ", " solid transparent;\n  border-right: ", " solid transparent;\n\n  textarea {\n    &:focus {\n      outline: none;\n    }\n  }\n\n  ", "\n"])), th.space(4), th.space(4), up('sm', css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      border-radius: editor;\n      margin: 3 -2;\n    "])))));
var LivePreview = styled(BaseLivePreview)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  padding: preview-padding-y preview-padding-x;\n  margin: 3 -3 -3;\n  border-top: 1;\n  border-color: editor-border;\n  border-image: initial;\n\n  white-space: normal;\n  font-family: base;\n  overflow: hidden;\n\n  background-color: background;\n  color: on-background;\n\n  ", "\n"])), up('sm', css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      border-right: 1;\n      border-left: 1;\n      border-radius: editor;\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n      border-color: editor-border;\n      margin-left: -2;\n      margin-right: -2;\n    "])))));
var globalModules = {
  react: 'React'
};
export function LiveConfig(_ref) {
  var modules = _ref.modules;
  Object.assign(globalModules, modules);
  return null;
}

function req(path) {
  var dep = globalModules[path];

  if (!dep) {
    throw new Error("Unable to resolve path to module '" + path + "'. Use \"LiveConfig\" to provide modules.");
  }

  return dep;
}

function importToRequire(code) {
  return code // { a as b } => { a: b }
  .replace(/([0-9a-z_$]+) as ([0-9a-z_$]+)/gi, '$1: $2') // import { a } from "a" => const { a } = require("b")
  .replace(/import {([^}]+)} from ([^\s;]+);?/g, 'const {$1} = require($2);') // import a from "a" => const a = require("a").default || require("a")
  .replace(/import ([\S]+) from ([^\s;]+);?/g, 'const $1 = require($2).default || require($2);') // import * as a from "a"
  .replace(/import \* as ([\S]+) from ([^\s;]+);?/g, 'const $1 = require($2);') // import a from "a" => const a = require("a").default || require("a")
  .replace(/import (.+),\s?{([^}]+)} from ([^\s;]+);?/g, ['const $1 = require($3).default || require($3);', 'const {$2} = require($3);'].join('\n'));
}

export function usePrismTheme() {
  var theme = useTheme();
  return th('prism-theme')({
    theme: theme
  });
}
export function Code(_ref2) {
  var children = _ref2.children,
      _ref2$lang = _ref2.lang,
      lang = _ref2$lang === void 0 ? 'markup' : _ref2$lang,
      live = _ref2.live,
      noInline = _ref2.noInline;
  var prismTheme = usePrismTheme();

  if (live) {
    return /*#__PURE__*/React.createElement(LiveProvider, {
      code: children.trim(),
      transformCode: function transformCode(code) {
        return "/* @jsx mdx */ " + importToRequire(code);
      },
      scope: {
        mdx: mdx,
        require: req
      },
      language: lang,
      theme: prismTheme,
      noInline: noInline
    }, /*#__PURE__*/React.createElement(LivePreview, null), /*#__PURE__*/React.createElement(Pre, {
      as: "div",
      style: {
        borderTopLeftRadius: 0,
        borderTopRightRadius: 0
      }
    }, /*#__PURE__*/React.createElement(LiveEditor, {
      padding: 0
    })), /*#__PURE__*/React.createElement(LiveError, null));
  }

  return /*#__PURE__*/React.createElement(Highlight, Object.assign({}, defaultProps, {
    code: children.trim(),
    language: lang,
    theme: prismTheme
  }), function (_ref3) {
    var className = _ref3.className,
        style = _ref3.style,
        tokens = _ref3.tokens,
        getLineProps = _ref3.getLineProps,
        getTokenProps = _ref3.getTokenProps;
    return /*#__PURE__*/React.createElement(Pre, {
      className: className,
      style: style
    }, tokens.map(function (line, i) {
      return /*#__PURE__*/React.createElement("div", getLineProps({
        line: line,
        key: i
      }), line.map(function (token, key) {
        return /*#__PURE__*/React.createElement("span", getTokenProps({
          token: token,
          key: key
        }));
      }));
    }));
  });
}